import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppRoutingModule, routes} from './app-routing.module';
import { AppComponent, UploadInterceptor } from './app.component';
import { HeaderComponent, LoginDialog, RegisterDialog, ForgotPasswordDialog } from './shared/layout/header/header.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { DateInputsModule, TimePickerModule } from '@progress/kendo-angular-dateinputs';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { ErrorpageComponent } from './errorpage/errorpage.component';
import { ErrorInterceptor } from '../app/helpers/error.interceptor';
import { AuthGuard } from './authentication/guards/auth-guard.service';
import { ToastrModule } from 'ngx-toastr';
import { MatSelectModule, MatDialogModule, MatInputModule, MatButtonModule, MatCardModule, MatDatepickerModule, MatNativeDateModule, MatTabsModule, MatCheckboxModule, MatListModule, MatSnackBarModule } from '@angular/material';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { FontsizeModifierComponent } from './shared/layout/fontsize-modifier/fontsize-modifier.component';
import { NavbarComponent } from './shared/layout/navbar/navbar.component';
import { KendoDropdownlistModule } from '../kendo-dropdownlist/kendo-dropdownlist.module';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouteMapDialog, TimeTableDialog, StopsDialog } from './main/busservices/busservices.component';
import { PerfectScrollbarModule, PerfectScrollbarConfigInterface, PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { UpdatefontsizeService } from './services/updatefontsize.service';
import { CookieService } from 'ngx-cookie-service';



// import { PdfViewerModule } from 'ng2-pdf-viewer'; // <- import PdfViewerModule

//import { ToastrModule } from 'ngx-toastr';
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  wheelPropagation: true
};


// import { BotDetectCaptchaModule } from 'angular-captcha';
@NgModule({
  entryComponents: [HeaderComponent, LoginDialog, RegisterDialog, ForgotPasswordDialog, RouteMapDialog,TimeTableDialog,StopsDialog],
  declarations: [
    AppComponent,
    HeaderComponent,

    FontsizeModifierComponent,
    LoginDialog,
    RegisterDialog,
    ForgotPasswordDialog,
    NavbarComponent,

    RouteMapDialog,
    TimeTableDialog,
    StopsDialog,

  //  ErrorpageComponent
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    DateInputsModule,
    InputsModule,
    KendoDropdownlistModule,
    MatSelectModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatCardModule,
    MatSnackBarModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTabsModule,
    MatCheckboxModule,
    MatListModule,
    MatNativeDateModule,
    MatTabsModule,
    FormsModule,
    ReactiveFormsModule,
    PerfectScrollbarModule,
    MatTooltipModule,
    // PdfViewerModule,
    // CookieService,

    RouterModule.forRoot(routes, {useHash: true}),
    ToastrModule.forRoot({
      progressBar: true
    }),
    NgbModule,
    // BotDetectCaptchaModule
  ],
  providers: [
    DatePipe,
    AuthGuard,
    CookieService,
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: UploadInterceptor,multi: true },



      {
        provide: PERFECT_SCROLLBAR_CONFIG,
        useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
      },
      UpdatefontsizeService
  ],
  bootstrap: [AppComponent]


})
export class AppModule {

  ngOnInit(){
    alert("1");
  }
}
